"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDeliveryOptionsDialog = useDeliveryOptionsDialog;
var _environment = require("@ori/environment");
var _staticApiClientReact = require("@ori/static-api-client-react");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _constants = require("../../constants");
var _swrConfig = require("../../constants/swrConfig");
var _addressFormContext = require("../../contexts/addressFormContext");
var _hooks = require("../../hooks");
var _models = require("../../models");
var _usePickupPointsDialog = require("./usePickupPointsDialog");
/**
 * Helper hook for delivery options dialog logic.
 * @obsolete Can be dropped later when flat selection UI is used in all markets.
 */
function useDeliveryOptionsDialog({
  isAddHomeDeliveryAddressAllowed,
  isDeliveryOptionsLoaded,
  isDeliveryOptionsLoading,
  isDisplayingAddresses,
  isMapEnabled,
  isPickUpAvailable,
  lastDeliveryItemFee,
  lastDeliveryItemMethod,
  onDeliveryItemActivation,
  setIsDisplayingAddresses
}) {
  const {
    formatMessage
  } = (0, _hooks.useTranslations)();
  const {
    getTestIdProps
  } = (0, _testidGenerator.default)();
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    data: {
      isEnabled: isMapListMergeEnabled
    } = {
      isEnabled: false
    }
  } = (0, _staticApiClientReact.useGetTenantFeatureToggle)(tenant, _constants.MapListMergeFeatureToggle, {
    swr: _swrConfig.basicSwrOptions
  });
  const {
    onCreateAddress
  } = (0, _addressFormContext.useAddressForm)();
  const {
    isFindPickupPointsOpen,
    togglePickupPointsDialog
  } = (0, _usePickupPointsDialog.usePickupPointsDialog)();
  const newDeliveryProps = {
    isAddHomeDeliveryAddressAllowed,
    isPickUpAvailable,
    lastDeliveryItemFee,
    lastDeliveryItemMethod,
    onCreateAddress,
    togglePickupPointsDialog
  };
  const historyToggleProps = {
    ...getTestIdProps(_models.TestId.DeliveryToggleHistoryAddress),
    checked: isDisplayingAddresses,
    firstText: formatMessage('history'),
    secondText: formatMessage('addresses'),
    onChange: ({
      currentTarget: {
        checked
      }
    }) => setIsDisplayingAddresses(checked)
  };
  const findPickupPointsProps = {
    isMapEnabled,
    onDeliveryItemActivation,
    togglePickupPointsDialog
  };
  const deliveryOptionsTitle = formatMessage('deliveryOptions');
  return {
    deliveryOptionsTitle,
    findPickupPointsProps,
    historyToggleProps,
    isAddHomeDeliveryAddressAllowed,
    isDeliveryOptionsLoaded,
    isDeliveryOptionsLoading,
    isDisplayingAddresses,
    isFindPickupPointsOpen,
    isMapEnabled,
    isMapListMergeEnabled,
    isPickUpAvailable,
    newDeliveryProps,
    togglePickupPointsDialog
  };
}